module.exports = __webpack_public_path__ + "img/intmedius.73fd5867.png";